import React, { useState, useEffect } from "react";
import registration from "../../assets/images/registration-img.png";
import { toast } from "react-toastify";
const ForgotPasswordModal = ({ setEmailvarify }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState("");
  const [timeLeft, setTimeLeft] = useState(0); // Start with 0
  const [isActive, setIsActive] = useState(false); // Start inactive

  useEffect(() => {
    let interval = null;
    if (isActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsActive(false);
    }
    return () => clearInterval(interval);
  }, [timeLeft, isActive]);

  const startTimer = () => {
    setTimeLeft(5 * 60); // 5 minutes
    setIsActive(true);
  };

  const formatTime = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const validateForgotPass = () => {
    const toastId = "validate-phone";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      if (!toast.isActive(toastId)) {
        toast.error("Please enter an email address", { toastId: toastId });
      }
      return false;
    }

    if (!emailRegex.test(email)) {
      if (!toast.isActive(toastId)) {
        toast.error("Please enter a valid email address", { toastId: toastId });
      }
      return false;
    }

    return true;
  };

  const resetForm = () => {
    setEmail("");
    setLoading(false);
    setTimeLeft(0);
    setIsActive(false);
  };

  useEffect(() => {
    const forgotModal = document.getElementById("forgot");

    forgotModal.addEventListener("hidden.bs.modal", resetForm);
    forgotModal.addEventListener("show.bs.modal", resetForm);

    return () => {
      forgotModal.removeEventListener("hidden.bs.modal", resetForm);
      forgotModal.removeEventListener("show.bs.modal", resetForm);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForgotPass()) {
      setLoading(true);
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/emails/send-email-otp-auth`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ name: email, email: email }),
          }
        );
        const data = await res.json();
        // console.log(data);
        if (data.success) {
          resetForm();
          startTimer(); // Start timer when OTP is sent successfully
          toast.success(data.message);
          const forgotModalEl = document.getElementById("forgot");
          const forgotInstance =
            window.bootstrap.Modal.getInstance(forgotModalEl);
          forgotInstance.hide();

          const otpModalEl = document.querySelector("#new-password");
          const otpModal = new window.bootstrap.Modal(otpModalEl);
          otpModal.show();
          setEmailvarify(email);
        } else {
          resetForm();
          setLoading(false);
          toast.error(data.message);
        }
      } catch (error) {
        resetForm();
        // console.log("otp send error", error);
      }
    }
  };
  return (
    <>
      <div
        className="modal fade registration"
        id="forgot"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="fa fa-times" />
            </button>
            <div className="modal-body">
              <div className="row gx-0">
                <div className="col-lg-6 h-100 d-xl-block d-lg-block d-none">
                  <div className="registration-img">
                    <img
                      src={registration}
                      className="w-100 h-100"
                      alt="registration"
                    />
                    <div className="registration-content">
                      <h3 className="text-white">Forgot Password</h3>
                      <p className="text-white">
                        Please provide your registered Email address. Get
                        started into
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="registration-frm">
                    <h4 className="title d-lg-none d-block">Forgot Password</h4>
                    <form action="" onSubmit={handleSubmit}>
                      <div className="registration-bx">
                        <label htmlFor="">Email Address</label>
                        <input
                          type="email"
                          name="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          className="form-control mobile"
                          placeholder="Enter Email Address"
                          maxLength={50}
                        />
                      </div>
                      <div className="registration-bx">
                        <button
                          className="thm-btn dark w-100 rounded-5 p-3 bg-btn"
                          type="submit"
                          disabled={loading}
                          // data-bs-toggle="modal"
                          // data-bs-target="#new-password"
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Get Otp"
                          )}
                        </button>
                      </div>
                      <p className="clr fz-18 text-center mt-4">
                        Already have an account?{" "}
                        <a
                          href="javascript:void(0);"
                          data-bs-toggle="modal"
                          data-bs-target="#login"
                          className="txt-org fw-600"
                        >
                          Login
                        </a>
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordModal;
